"use client"
import { getRefTaToken } from "utils/local-storage"

import { isClientPreviewActive } from "./previewMode"

/**
 * Hook to determine if the current user is a travel agent client.
 * Returns `true` if `getRefTaToken` exist, OR when the URL contains
 * `?preview=client` so an agent can preview the client view.
 */
export function useIsTravelAgentClient() {
  const refTaToken = getRefTaToken()
  if (isClientPreviewActive()) return true
  return !!refTaToken
}
